export default __webpack_public_path__ + "ad88969704f26c333e7e737b96bb5ea7.gif";